(function () {
  function init() {
    var carousels = document.querySelectorAll('.fatboy-hype-carousel');
    if (!carousels.length) return;

    var lazyWrappers = document.querySelectorAll('.fatboy-hype-video-wrapper[data-hype-lazy]');
    if (lazyWrappers.length) {
      var activate = function (wrapper) {
        if (wrapper.dataset.hypeActivated === '1') return;
        wrapper.dataset.hypeActivated = '1';
        var tpl = wrapper.querySelector('.fatboy-hype-video-tpl');
        if (!tpl || !tpl.content) return;
        wrapper.appendChild(tpl.content.cloneNode(true));
        wrapper.classList.add('is-activated');
      };

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              activate(entry.target);
              obs.unobserve(entry.target);
            }
          });
        }, { rootMargin: '300px 0px', threshold: 0.01 });
        lazyWrappers.forEach(function (w) { io.observe(w); });
      } else {
        lazyWrappers.forEach(activate);
      }
    }

    carousels.forEach(function (carousel) {
      var slides = carousel.querySelector('.fatboy-hype-slides');
      var dots = carousel.querySelectorAll('.fatboy-hype-dot');
      var allSlides = carousel.querySelectorAll('.fatboy-hype-slide');
      if (!slides || dots.length === 0) return;

      var desktopMQ = window.matchMedia('(min-width: 769px)');
      var itemsPerPage = desktopMQ.matches ? 4 : 1;
      var slideOffsets = [];
      var scrollScheduled = false;
      var activeDotIndex = -1;

      var cacheOffsets = function () {
        slideOffsets = Array.from(allSlides, function (s) { return s.offsetLeft; });
      };

      var updateDotsVisibility = function () {
        dots.forEach(function (dot, index) {
          var visible = index % itemsPerPage === 0 && index < allSlides.length;
          dot.style.display = visible ? 'block' : 'none';
        });
      };

      var setActiveDot = function (idx) {
        if (idx === activeDotIndex) return;
        activeDotIndex = idx;
        dots.forEach(function (dot, index) { dot.classList.toggle('active', index === idx); });
      };

      var onScroll = function () {
        if (scrollScheduled) return;
        scrollScheduled = true;
        requestAnimationFrame(function () {
          scrollScheduled = false;
          if (!slideOffsets.length) cacheOffsets();
          var scrollLeft = slides.scrollLeft;
          var bestIdx = 0;
          var minDistance = Infinity;
          for (var i = 0; i < slideOffsets.length; i++) {
            if (i % itemsPerPage !== 0) continue;
            var distance = Math.abs(slideOffsets[i] - scrollLeft);
            if (distance < minDistance) {
              minDistance = distance;
              bestIdx = i;
            }
          }
          setActiveDot(bestIdx);
        });
      };

      var onResize = function () {
        itemsPerPage = desktopMQ.matches ? 4 : 1;
        cacheOffsets();
        updateDotsVisibility();
        onScroll();
      };

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var slideIndex = parseInt(dot.dataset.slide, 10);
          var slideElement = allSlides[slideIndex];
          if (!slideElement) return;
          slides.scrollTo({ left: slideElement.offsetLeft, behavior: 'smooth' });
          setActiveDot(slideIndex);
        });
      });

      slides.addEventListener('scroll', onScroll, { passive: true });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(onResize, 150);
      }, { passive: true });

      cacheOffsets();
      updateDotsVisibility();
      onScroll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
